export type SessionLandingType = "parlor" | "facility" | "crematorium";
// | "guidebook";

export const 랜딩페이지_LIST_EVENT_KEY: Record<SessionLandingType, SessionLandingType> = {
  parlor: "parlor",
  facility: "facility",
  crematorium: "crematorium",
  // guidebook: "guidebook",
};

export const 랜딩페이지_LIST_EVENT_KEYS = Object.keys(랜딩페이지_LIST_EVENT_KEY);
